"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { TextField } from "@/components/Field";
import { useAuth } from "@/lib/auth";
import { AlertOctagon } from "lucide-react";

export function LoginForm() {
  const router = useRouter();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function handleSubmit() {
    setBusy(true);
    setError("");
    const res = await login(username, password);
    setBusy(false);
    if (res.ok) {
      router.push("/");
    } else {
      setError(res.error ?? "Login failed.");
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <TextField label="Username" required value={username} onChange={setUsername} />
      <TextField label="Password" required type="password" value={password} onChange={setPassword} />
      {error && (
        <div className="flex items-start gap-2 rounded-sm border border-[var(--alert)]/40 bg-[#e8563d0d] px-3 py-2 text-[12.5px] text-[var(--alert)]">
          <AlertOctagon size={14} className="mt-0.5 shrink-0" />
          <span>{error}</span>
        </div>
      )}
      <button
        onClick={handleSubmit}
        disabled={busy || !username || !password}
        className="gradient-btn rounded-sm px-5 py-2.5 text-[13px] font-medium disabled:cursor-not-allowed disabled:opacity-40"
      >
        {busy ? "Signing in…" : "Sign in"}
      </button>
      <p className="text-center text-[12.5px] text-[var(--muted)]">
        New applicant?{" "}
        <Link href="/register-owner" className="text-[var(--blue)] hover:underline">
          Register here
        </Link>
      </p>
    </div>
  );
}
